export default __webpack_public_path__ + "locales/lo-LA/FilesSettings.json?hash=b41a7fa3f9b2b28b3bc98959eff043e8";